export default __webpack_public_path__ + "static/media/company_inactive.ce41eea4.svg";